'use strict';

$(function () {

  var storeLocatorContainer = $(document).find('[data-map-app-container]');

  if (storeLocatorContainer.length) {
    addKmToDistanceOptions();
  }

  //implementation

  function addKmToDistanceOptions() {

    waitForOptionsToLoad(function (options) {
      return options.forEach(function (o) {
        return o.text != 'No Limit' && (o.text += 'km');
      });
    });

    function waitForOptionsToLoad(action) {
      var changeObserver = new MutationObserver(function () {
        var options = Array.from(storeLocatorContainer.find('[data-radius-select] option'));
        if (options.length) {
          action(options);
          changeObserver.disconnect();
        }
      });
      changeObserver.observe(storeLocatorContainer[0], { attributes: true, childList: true, subtree: true });
    }
  }
});